export const ActionTypes = {
  FETCH_HIGHLIGHTS_BY_USER: 'services/downtimeReasonHighlights/fetch_by_user',
  SET_HIGHLIGHTS_BY_USER: 'services/downtimeReasonHighlights/set_by_user',
  SET_LOADER_STATUS: 'services/downtimeReason/set_loader_status',
  BULK_UPDATE_HIGHLIGHTS: 'services/downtimeReasonHighlights/bulk_update',
};

const fetchHighlightsByUser = userId => ({
  userId,
  type: ActionTypes.FETCH_HIGHLIGHTS_BY_USER,
});

const setHighlightsByUser = ({ highlightsByUser }) => ({
  highlightsByUser,
  type: ActionTypes.SET_HIGHLIGHTS_BY_USER,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const bulkUpdateHighlights = params => ({
  params,
  type: ActionTypes.BULK_UPDATE_HIGHLIGHTS,
});

export default {
  fetchHighlightsByUser,
  setHighlightsByUser,
  setLoader,
  bulkUpdateHighlights,
};
